import {
  createUniversalReporter,
  createSemanticMetrics,
} from '@spotify-internal/semantic-metrics';
import { createRouteMetrics } from '@spotify-internal/next-router-metrics';

const { sendMetric } = createSemanticMetrics({
  key: 'www-marketing',
  reporter: createUniversalReporter(),
  // uncomment if the key is not the same as your component_id
  // component_id: 'www-marketing',
});

const withRouteMetrics: ReturnType<typeof createRouteMetrics> =
  createRouteMetrics(sendMetric);

export { sendMetric, withRouteMetrics };
